import { Document, Packer, Paragraph, TextRun } from 'docx';
import { saveAs } from 'file-saver';
export const downloadWord = (testtext:Array<any>, docname?:string) => {
    // Split text into paragraphs based on line breaks
    const paragraphs = testtext.join(', ').split('\n').map((text:string) => new Paragraph({
      children: [
        new TextRun(text),
      ],
      alignment: "distribute",
      style: "ListParagraph"
    }));

    const doc = new Document({
      sections: [{
        properties: {},
        children: paragraphs,
      }],
    });


    Packer.toBlob(doc).then(blob => {
      saveAs(blob, `${docname ? docname : 'Document'}.docx`);
    });
  };